import axios from 'axios'

async function get_jobs(email,setData,add_jobs,dispatch,token){

try{

  const data = {
    email:email
  }

  const getJobs = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-user-jobs/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

  if (getJobs?.status == 200 && getJobs?.data.success == true) {

  setData(getJobs?.data.jobs)
  dispatch(add_jobs(getJobs?.data.jobs))
  
}
}catch(err){
  console.log(err)
}
}

export default get_jobs